<script lang="ts">
  import { onDestroy, onMount } from "svelte";

  import Window from "../components/Window.svelte";
  import type { WinCbs, WinProps } from "../scripts/WinTypes";
  export let winProps: WinProps;

  const setWinProps = () => {
    winProps.name = winProps.name || "About";

    if (!winProps.data) {
      winProps.data = {};
    }
    winProps["data"]["rect"] = winProps.data?.rect || {
      top: "20%",
      left: "20%",
      width: "60%",
      height: "60%",
    };
  };
  setWinProps();
  // winProps["maximizeOnMount"] = true;

  let bgTopElem: HTMLElement, bgBottomElem: HTMLElement;
  let textElem: HTMLElement, emailElem: HTMLElement, msgElem: HTMLElement;
  let toggleBackground;
  const toggleFunc = () => {
    bgTopElem.classList.toggle("active");
    bgBottomElem.classList.toggle("active");
  };
  let clicked = false;
  $: msg = clicked ? "Copied!" : "Click to copy";

  onMount(() => {
    // toggleBackground = setInterval(toggleFunc, 1000);
    setTimeout(toggleFunc, 1);
    setTimeout(() => {
      bgTopElem.style.opacity = "0";
      bgBottomElem.style.opacity = "0";
      const children = textElem.children;
      for (let i = 0; i < children.length; ++i) {
        (children[i] as HTMLElement).style.color = "#222";
      }
    }, 1500);
  });
  onDestroy(() => {
    // clearInterval(toggleBackground);
  });
  const _copy = (e) => {
    clicked = true;
    // console.log(e.target);
    // e.target.
    //   let tempElem = document.createElement('textarea');
    // tempElem.value = emailElem.innerText;
    // document.body.appendChild(tempElem);

    // tempElem.select();
    // document.execCommand('copy');
    navigator.clipboard.writeText("iamjam4944@gmail.com");
    msgElem.style.color = "#27e8a7";
  };
</script>

<Window {winProps}>
  <div class="container">
    <div class="background top" bind:this={bgTopElem} />
    <div class="background bottom" bind:this={bgBottomElem} />
    <div class="icon-container">
      <img class="icon" src="/imgs/jamos512.png" alt="JamOS logo" />
    </div>
    <div class="text-container" bind:this={textElem}>
      <h1 class="t title">JamOS v0.2</h1>
      <p class="t desc">designed & developed by Wonjun Hwang</p>
      <p class="t desc">
        contact : <strong
          class="copiable"
          on:click={_copy}
          bind:this={emailElem}
          ><span class="underline" />iamjam4944@gmail.com<span
            class="clicked"
            bind:this={msgElem}>{msg}</span
          ></strong
        >
      </p>
    </div>
  </div>
  <div class="css-keeper background active" />
</Window>

<style>
  .copiable {
    font-weight: 400;
    position: relative;
    transition: 0.2s;
    display: inline-block;
  }
  .underline {
    position: absolute;
    bottom: 0;
    left: 0;
    margin: 0;
    width: 0%;
    transition: 0.2s;
    border-bottom: 1px solid #333;
    box-shadow: 1px 1px 1px #333;
  }
  .clicked {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(60%, -60%) rotate(10deg);
    font-size: 0.9rem;
  }
  .copiable:hover {
    cursor: pointer;
    transform: translate(-1px, -1px);
  }
  .copiable:hover .underline {
    width: 100%;
  }
  .copiable:hover .clicked {
    display: inline;
  }
  .copiable:active {
    transition: 0.1s;
    background-color: #3337;
    transform: translate(0px, 0px);
  }
  .container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    overflow: hidden;
    background-color: #dbdbdb;
    margin: 0;
    color: #333;
    flex-direction: column;
    padding-top: 10px;
    padding-bottom: 10px;
    box-sizing: border-box;
    gap: 20px;
  }
  .background {
    position: absolute;
    width: 0%;
    transition: 1.5s;
    background-color: #333;
    /* mix-blend-mode: multiply; */
  }
  .background.top {
    top: 0;
    right: 0;
    width: 0%;
    height: 62%;
    background-color: #777;
  }
  .background.bottom {
    bottom: 0;
    left: 0;
    width: 0%;
    height: 38%;
  }
  .background.active {
    width: 100%;
  }
  .icon-container {
    position: relative;
    flex: 3;
    margin: 0 auto;
    overflow: hidden;
  }
  .text-container {
    position: relative;
    flex: 2;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .t {
    color: #dbdbdb;
    text-align: center;
    margin: 0;
    transition: 1.5s;
  }
  .title {
    font-size: 2rem;
  }
  .desc {
    font-size: 1.3rem;
  }
  .icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center center;
  }
  .css-keeper {
    display: none;
  }
</style>
